import React from "react";
import { useDispatch, useSelector } from "react-redux";
import logo from "../assets/images/logo.png";
import { switchpage } from "../redux/router/actions";

export default function Navbar() {
  const dispatch = useDispatch();
  const { cart } = useSelector((store) => store.product);

  const totalQuantity = cart.reduce(
    (sum, { quantity }) => sum + parseInt(quantity),
    0
  );

  function goHome() {
    dispatch(switchpage("home"));
  }
  function goCart() {
    dispatch(switchpage("cart"));
  }

  return (
    <nav className="bg-[#171C2A] py-4">
      <div className="navBar">
        <a href="/">
          <img src={logo} alt="LWS" className="max-w-[140px]" />
        </a>

        <div className="flex gap-4">
          <button onClick={goHome} className="navHome" id="lws-home">
            Home
          </button>
          <button onClick={goCart} className="navCart" id="lws-cart">
            <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
            <span id="lws-totalCart">{totalQuantity}</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
